"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationResultCheck = exports.validationResultTry = void 0;
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
function validationResultTry(result, callbackIfValid) {
    if (result instanceof InvalidResult_1.default) {
        return result;
    }
    return callbackIfValid(result);
}
exports.validationResultTry = validationResultTry;
/**
 * Throws an error if the validation result is an instance of InvalidResult
 */
function validationResultCheck(result) {
    if (result instanceof InvalidResult_1.default) {
        throw new Error(`Invalid result: ${result.reason}`);
    }
    return result;
}
exports.validationResultCheck = validationResultCheck;
